import { render, staticRenderFns } from "./ColorModuleHeader.vue?vue&type=template&id=b0b593ce&scoped=true"
import script from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
export * from "./ColorModuleHeader.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleHeader.vue?vue&type=style&index=0&id=b0b593ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b593ce",
  null
  
)

export default component.exports